import { AutService } from '../auth/aut.service';
import { FunctionsService } from './functions.service';
import { pages } from '../constants';

export function appInitializer(authenticationService: AutService, func: FunctionsService) {
    return () => new Promise<void>((resolve) => {
        // resolve();
        authenticationService.refreshToken().subscribe(() => {}, () => {
                func.setNavigation(pages.errors).finally();
            }).add(resolve());
    });
}
